<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <!-- title  -->
    <h1 class="mb-2">{{ getTitle }}</h1>

    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-3">
          <v-row class="mb-0 pb-0">
            <v-col class="pb-0" cols="12" md="12">
              <el-button
                v-if="showRejectBtn"
                class="mr-1"
                title="Atmesti pasirašančius asmenis"
                :loading="loading"
                @click.native="beforeReject()"
                color="danger"
              />
              <el-button
                v-if="showApproveBtn"
                class="mr-1"
                color="primary"
                title="Patvirtinti pasirašančius asmenis"
                @click.native="beforeApprove()"
                :loading="loading"
              />
            </v-col>
          </v-row>
          <v-row class="mb-0 pb-0">
            <v-col cols="6" md="6">
              <h2 class="ml-4 mb-3">{{ $t('Dokumento informacija') }}</h2>
              <el-simple-table v-if="!loading" :items="documentInfoList" />
            </v-col>
            <v-col cols="6" md="6">
              <h2 class="ml-4 mb-3">{{ $t('Pasirašantys asmenys') }}</h2>
              <el-simple-table
                v-if="!loading"
                :items="documentSigningPersonsList"
              />
            </v-col>
          </v-row>
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="6">
              <h2 class="ml-4 mb-3">{{ $t('Kiti duomenys') }}</h2>
              <el-simple-table
                v-if="!loading"
                :items="otherDataList"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </form>
      <!-- modals -->
      <!-- <modal-custom
        :title="$t('Pasirašančiųjų atmetimas')"
        :text="$t('Ar tikrai norite atmesti pasirašančius asmenis?')"
        trueText="Taip"
        falseText="Ne"
        :loading="loading"
        v-model="showCancelModal"
        @confirmData="confirmReject"
      /> -->
      <modal-confirm
      :title="$t('Pasirašančiųjų atmetimas')"
      :text="$t('Ar tikrai norite atmesti pasirašančius asmenis?')"
      v-model="showCancelModal"
      :loading="loading"
      :rejectReason="true"
      :rejectReasonType="'invalid-representers'"
      @rejectReasonText="ReasonText"
      @rejectReasonTextEN="ReasonTextEN"
      @confirmData="confirmReject"
    />
      <modal-custom
        :title="$t('Pasirašančiųjų patvirtinimas')"
        :text="$t('Ar tikrai norite patvirtinti pasirašančius asmenis?')"
        trueText="Taip"
        falseText="Ne"
        :loading="loading"
        v-model="showApproveModal"
        @confirmData="confirmApprove"
      />
    </v-card>
    <v-card-actions>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <el-button
          class="mr-2"
          tile
          @click.native="back()"
          :loading="loading"
          title="Atgal"
        />
      
      </v-row>
    </v-card-actions>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import { throws } from 'assert'
import ModalCustom from '@/components/modals/ModalCustom'
import ModalConfirm from '@/components/modals/ModalConfirm'
export default {
  name: 'CheckingInJournalForm',
  components: { ModalCustom, ModalConfirm },
  mixins: [userRole],
  data() {
    return {
      showCancelModal: false,
      showApproveModal: false,
      inJournal: {},
      signingPersons: [],
      pageloading: false,
      formData: {},
      loading: false,
    }
  },
  computed: {
    documentInfoList() {
      return [
        {
          title: this.$t('Reg. Nr. nepatikrintų dokumentų žurnale'),
          value: this.getDocumentNo,
        },
        {
          title: this.$t('Nepatikrinto dokumento pavadinimas'),
          enumName: 'inJournalType',
          value: this.getDocumentType,
        },
        {
          title: this.$t('Gavimo data ir laikas'),
          value: this.getDocumentReceiveDate,
        },
      ]
    },
    documentSigningPersonsList() {
      let result = []

      this.signingPersons.map((person) => {
        result.push({
          title: person.type == 'JUR' ? this.$t('Juridinis asmuo') : this.$t('Fizinis asmuo'),
          value: person.fullname,
        })

        person.children.map((child) => {
          result.push({
            title: this.$t('Atstovas'),
            value: child.fullname,
          })
        })
      })
      return result
    },
    otherDataList() {
      return [
        {
          title: this.$t('Sprendimas'),
          value: this.getDocumentSigningStatus,
        },
        {
          title: this.$t('Sprendimo data'),
          value: this.getDocumentSigningStatusDate,
        },
        {
          title: this.$t('Tvarkė'),
          value: this.getDocumentRegistrar,
        },
        {
          title: this.$t('PAS prašymo numeris'),
          value: this.inJournal.ns_pas_number,
        },
        {
          title: this.$t('Atmetimo aprašymas (LT)'),
          value: this.inJournal.ns_reject_reason_lt,
          hide: !this.inJournal.ns_reject_reason_lt
        },
        {
          title: this.$t('Atmetimo aprašymas (EN)'),
          value: this.inJournal.ns_reject_reason_en,
          hide: !this.inJournal.ns_reject_reason_en
        }
      ]
    },
    getTitle() {
      return `${this.$t('Dokumentas')}: ${this.getDocumentNo}`
    },
    getDocumentNo() {
      return this.inJournal.ns_number  || ''
    },
    getDocumentReceiveDate() {
      return this.inJournal.received_date
    },
    getDocumentRegistrar() {
      return this.inJournal.registrar
    },
    getDocumentSigningStatus() {
      return this.inJournal.signing_status
    },
    getDocumentSigningStatusDate() {
      return this.inJournal.signing_status_date
    },
    getDocumentType() {
      return this.inJournal.in_journal_type
    },
    getId() {
      return this.$route.params.id || null
    },
    showRejectBtn() {
      return this.inJournal.canChangeSigningStatus || false
    },
    showApproveBtn() {
      return this.inJournal.canChangeSigningStatus || false
    },
    getNsRejectReason() {
      return this.inJournal.ns_reject_reason_lt || ''
    },
    getNsRejectReasonLT() {
      return this.inJournal.ns_reject_reason_lt || ''
    },
    getNsRejectReasonEn() {
      return this.inJournal.ns_reject_reason_en || ''
    },
  },
  created() {
    this.getData()
  },
  methods: {
    ReasonText(text){
      this.rejectReason = text
    },
    ReasonTextEN(text){
      this.rejectReasonEN = text
    },
    back() {
      this.$router.push({name: 'checkingJournal'})
    },
    getData() {
      this.pageloading = true
      this.$axios
        .get(`in-journals/${this.getId}/ns`)
        .then((res) => {
          this.inJournal = res.data.inJournal.journal_data
          this.signingPersons = res.data.inJournal.signing_persons
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    beforeReject() {
      this.showCancelModal = true
    },
    beforeApprove() {
      this.showApproveModal = true
    },
    confirmReject() {
      this.rejectNs()
    },
    confirmApprove() {
      this.approveNs()
    },
    rejectNs() {
      this.loading = true
      this.pageloading = true
      this.$axios
        .post(`in-journals/${this.getId}/rejectNs`, {
          'ns_reject_reason_lt': this.rejectReason,
          'ns_reject_reason_en': this.rejectReasonEN
        })
        .then((res) => {
          this.back()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.showCancelModal = false
          this.loading = false
          this.pageloading = false
        })
    },
    approveNs() {
      this.loading = true
      this.pageloading = true
      this.$axios
        .post(`in-journals/${this.getId}/approveNs`)
        .then((res) => {
          this.back()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.showApproveModal = false
          this.loading = false
          this.pageloading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
